<div [formGroup]="group" class="form-input {{config.size.toString()}}" *ngIf="isVisible">
    <wtf-errors-indicator [errors]="errors" [ngClass]="{'inline-error': inline}"></wtf-errors-indicator>

    <mat-form-field *ngIf="!inline">
        <input matInput type="{{config.fieldInfo.type}}"  class="form-control" placeholder="{{config.fieldInfo.placeholder}}" [formControlName]="config.fieldInfo.name" (focus)="onFocus($event)" (blur)="onLostFocus($event)" />
    </mat-form-field>

    <label for="config.fieldInfo.name" class="label" *ngIf="inline">{{config.fieldInfo.caption}}</label>
    <input matInput type="{{config.fieldInfo.type}}" *ngIf="inline" class="form-control inline-field" [formControlName]="config.fieldInfo.name" (focus)="onFocus($event)" (blur)="onLostFocus($event)" />
</div>